// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"7d741442","498":"e3836896","703":"df82c703","908":"4abf4ad3"}[chunkId] + ".chunk.js";
};